import styled from '@emotion/styled';
import React from 'react';
import InputDateForm from '../../../../components/input/InputDateForm';
import { SelectSearch } from '../../../../components/select/SelectSearch';
import { getVendaStatusList } from '../../../../enum/VendaStatus';
import moment from 'moment';

const Search = ({ setFilters, filters }) => {
  const { dataInicial, dataFinal, statusList } = filters;

  const handleChange = (value, field) => {
    if ((field === 'dataInicial' || field === 'dataFinal') && (!value || value === 'Invalid date')) return;

    setFilters({
      ...filters,
      [field]: value,
    });
  };

  return (
    <HeaderContainer>
      <InputDateForm
        placeholder="Data início"
        variant="outlined"
        fullWidth
        value={dataInicial}
        onChange={(e) => handleChange(moment(e).format('YYYY-MM-DD'), 'dataInicial')}
      />
      <InputDateForm
        placeholder="Data final"
        variant="outlined"
        fullWidth
        value={dataFinal}
        onChange={(e) => handleChange(moment(e).format('YYYY-MM-DD'), 'dataFinal')}
      />
      <SelectSearchStyled
        placeholder="Status"
        isMulti
        value={statusList}
        elements={getVendaStatusList()}
        onChange={(e) => handleChange(e, 'statusList')}
      />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  gap: 16px;
`;

const SelectSearchStyled = styled(SelectSearch)`
  width: 100%;
`;

export default Search;
